/* === CLAUDE 2026-10-01 #9 :: Carrousel Jill Paris (flèches, défilement auto, compatible hébreu) === */
(function () {
  if (customElements.get('jp-carousel')) return;
  class JpCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.jp-track');
      if (!this.track) return;
      this.rtl = getComputedStyle(this.track).direction === 'rtl';
      this.querySelectorAll('[data-jp-prev]').forEach((b) => b.addEventListener('click', () => this.go(-1)));
      this.querySelectorAll('[data-jp-next]').forEach((b) => b.addEventListener('click', () => this.go(1)));
      const ms = parseInt(this.dataset.autoplay || '0', 10);
      if (ms > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(() => { if (!this.paused) this.go(1); }, ms);
        this.addEventListener('mouseenter', () => { this.paused = true; });
        this.addEventListener('mouseleave', () => { this.paused = false; });
        this.addEventListener('focusin', () => { this.paused = true; });
        this.track.addEventListener('pointerdown', () => { this.paused = true; });
      }
    }
    disconnectedCallback() { if (this.timer) clearInterval(this.timer); }
    step() {
      const item = this.track.children[0];
      if (!item) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    go(dir) {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      const pos = Math.abs(t.scrollLeft);
      const sign = this.rtl ? -1 : 1;
      if (dir > 0 && pos >= max - 4) { t.scrollTo({ left: 0 }); return; }
      if (dir < 0 && pos <= 4) { t.scrollTo({ left: sign * max }); return; }
      t.scrollBy({ left: sign * dir * this.step() });
    }
  }
  customElements.define('jp-carousel', JpCarousel);
})();
/* === /CLAUDE 2026-10-01 #9 === */
